import { Component , Vue ,Prop} from "vue-property-decorator";
@Component
export default class luckBagMemsListModal extends Vue {
    @Prop() private activityItem!: any;
    params:any={
        id:'',
        baseId:'',//房间id
        sceneId:'',//场次id
    }
    luckList:any=[]
	api:any={
        luckyBagMemsListApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luckyBag/luckyMemsList",//活动中奖纪录查询
        luckyBagExport: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/luckyBag/luckyBagExport",//中奖名单导出
	}
	mounted() {
        if (this.activityItem.id) {
            this.params.id = this.activityItem.id
            this.params.baseId = this.activityItem.baseId
            this.params.sceneId = this.activityItem.sceneId
            this.luckyBagMemsListApi(this.params)
        }
        
	}
    luckyBagMemsListApi(act:any){//获取中奖纪录
        let url = `${this.api.luckyBagMemsListApi}?id=${act.id}&baseId=${act.baseId}&sceneId=${act.sceneId}`
        this.fetch({
            url: url,
            method: "get",
        }).then((res:any) => {
            this.luckList = res.data
            // this.luckList = [{"userId": 111,"nick": "昵称","mobileNo": "手机号","luckyTerm": "中奖内容","address": "收货地址","awardTime": "2022-01-02 11:22:33"}]
        }).catch((err:any)=>{
            this.$toast(err.msg)
        })	
    }
    exportBag(){
        let act = this.params
        let url = `${this.api.luckyBagExport}?id=${act.id}&baseId=${act.baseId}&sceneId=${act.sceneId}`
		window.location.href = url        
    }
    close(query:boolean){
        this.$emit('closeLuckList',query)
    }
}
